<template>
  <div>
    <div class="cur_pos">当前位置：<span class="linkto" @click="tohome">首页</span><img :src="imgUrl+'double_arrow.png'"/><span>申报通知</span><img :src="imgUrl+'double_arrow.png'"/><span>{{tabname}}</span></div>

    <div class="notice_list_outer">
      <div class="list_cont">
        <div>

        </div>
        <div class="notice_tab">
          <span class="tab_span" v-for="(item,index) in noticeTab" :class="{cur:index==tabNum}"
                @click="tabChange(index)">{{ item }}</span>
        </div>
        <div class="tab_content notilist" v-show="tabNum==0">
          <el-table :data="tablelist" stripe @cell-click="toDetail" :cell-class-name="ccn" style="width: 100%">
            <el-table-column prop="post_title" label="项目名称" width="780"></el-table-column>
            <el-table-column prop="level" label="项目级别" width="180"></el-table-column>
            <el-table-column prop="end_time" label="申报时限"></el-table-column>
          </el-table>

          <el-pagination
            background
            layout="prev, pager, next,jumper"
            :current-page="currentPage"
            :page-size="pagesize"
            :total="total"
            @current-change="handleCurrentChange">
          </el-pagination>
        </div>

        <div class="tab_content notilist" v-show="tabNum==1">
          <el-table :data="tablelist2" stripe @cell-click="toDetail" :cell-class-name="ccn" style="width: 100%">
            <el-table-column prop="post_title" label="通知公告名称" width="780"></el-table-column>
            <el-table-column prop="view_type" label="类型" width="180"></el-table-column>
            <el-table-column prop="published_time" label="发布时间"></el-table-column>
          </el-table>
          <el-pagination
            background
            layout="prev, pager, next,jumper"
            :current-page="currentPage2"
            :page-size="pagesize2"
            :total="total2"
            @current-change="handleCurrentChange2">
          </el-pagination>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  created() {
    this.$ajax.get(this.bUrl + 'api/portal/lists/report?page=1&pagesize=10')
      .then(function (res) {
        this.tablelist = res.data.data.list;
        this.total = res.data.data.total;
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      }.bind(this));

    this.$ajax.get(this.bUrl + 'api/portal/lists/news?page=1&pagesize=10')
      .then(function (res) {
        this.tablelist2 = res.data.data.list;
        this.total2 = res.data.data.total;

      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
  },
  name: 'notilist',
  data() {
    return {
    	tabname:'专项资金',
      tabNum: 0,
      noticeTab: ['专项资金', '通知公告'],
      currentPage: 1,
      pagesize: 10,
      total:0,
      currentPage2: 1,
      pagesize2: 10,
      total2:0,
      tablelist: [],
      tablelist2: []
    }
  },
  methods: {
  	tohome(){
  		this.$router.replace({name:'homepage'})
  	},
    tabChange(index) {
      this.tabNum = index;
      this.tabname = this.noticeTab[index]
    },
    ccn(row) {
    	let _date = row.row.published_time;
    	_date = _date.replace('年',',')
    	_date = _date.replace('月',',')
    	_date = _date.replace('日',',')
    	_date = new Date(_date)
    	_date = _date.getTime()
    	let curDate = new Date();
    	curDate = curDate.getTime()
    	let interval = curDate - _date;
    	if(interval<259200000&&row.columnIndex == 0){
    		return 'af'
    	}

//    if (row.row.statusName.indexOf('填写')>-1 && row.columnIndex == 0) {
//      return 'statwrite'
//    } else if (row.row.statusName.indexOf('提交')>-1 && row.columnIndex == 0) {
//      return 'statsubmit'
//    }
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.$ajax.get(this.bUrl + 'api/portal/lists/report?page='+currentPage+'&pagesize=10')
        .then(function (res) {
          this.tablelist = res.data.data.list;
          this.total = res.data.data.total;
        }.bind(this))
        .catch(function (error) {
          console.log(error);
        });


    },
    handleCurrentChange2(currentPage) {
      this.currentPage2 = currentPage;
      this.$ajax.get(this.bUrl + 'api/portal/lists/news?page='+currentPage+'&pagesize=10')
        .then(function (res) {
          this.tablelist2 = res.data.data.list;
          this.total2 = res.data.data.total;

        }.bind(this))
        .catch(function (error) {
          console.log(error);
        });

    },
    toDetail(row, column, event, cell) {
    		this.$router.push({name: 'notidetail',query: {id:row.id,type:row.view_type}})
    }
  }
}
</script>

<style scoped>

.notice_list_outer {
  background: #fff;
  min-height: 500px;
}

.list_cont {
  width: 1180px;
  margin: 0 auto;
}

.notice_tab {
  width: 100%;
  height: 50px;
  padding-top: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.notice_tab .tab_span {
  padding-bottom: 10px;
  border-bottom: 4px solid transparent;
  margin: 0 90px;
  cursor: pointer;
}

.notice_tab .tab_span.cur {
  color: #3A9FFF;
  border-bottom: 4px solid #3A9FFF;
}

.tab_content {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/NotiDeclare/notilist.vue